import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';

// deposit
export function depositAjaxTable(limit,pagination,id,created_at,code,master_id,coin_id,total_amount,convert_amount,tx_id,login){
	const data = request({
		url: config.url+'deposit_request/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&coin_id=' + coin_id + '&total_amount=' + total_amount + '&convert_amount=' + convert_amount + '&tx_id=' + tx_id + '&login=' + login,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function depositInfo(id){
	const data = request({
		url: config.url+'deposit_request/info?id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getDepositEdit(id){
	const data = request({
		url: config.url+'deposit_request/edit?id='+id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function depositEdit(postData){
	const data = request({
		url: config.url+'deposit_request/edit',
		method: 'post',
		data: postData,

	});

	return Promise.resolve(data);
}

// deposit
export function addressAjaxTable(limit,pagination,id,master_id,coin_id,address){
	const data = request({
		url: config.url+'deposit_address/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&master_id=' + master_id + '&coin_id=' + coin_id + '&address=' + address,
		method: 'get'
	});

	return Promise.resolve(data);
}